'use strict';

import MultilineText from '~/components/MultilineText';
import Loading from '~/components/Loading';

export default function AuthSuccessView({ scenario, name, imageSrc, descriptionKey, closeLabelKey, isFetching }) {
    return (
        <div>
            <div className="reg-modal__title">
                {scenario === 'agency' && <MultilineText text={__('[Registration][Success] Your request has been sent!')} />}
                {scenario !== 'agency' && <MultilineText text={__('[Registration][Success] Welcome, {name}!', { '{name}': name })} />}
            </div>
            {descriptionKey && <div className="reg-modal__text">
                {__(descriptionKey)}
            </div>}
            {scenario !== 'agency' && (
                <div className="reg-modal__btns">
                    <a role="button" className="button button-round" data-fancybox-close>{__(closeLabelKey)}</a>
                </div>
            )}
            <div className="reg-modal__img">
                <img src={imageSrc} alt="" />
            </div>
            <Loading active={isFetching} />
        </div>
    );
}
